<template>
    <div>
        <transferTableVue></transferTableVue>
    </div>
</template>

<script>
import transferTableVue from '@/components/Admin/Component/transferTable.vue';
export default {
    name: 'PadmawebTransferView',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
    components:{
        transferTableVue
    }
};
</script>

<style lang="scss" scoped>

</style>